import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class TimezoneHttpInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const contextRequest = request.clone({
            headers: request.headers.set('TimezoneOffsetMinutes', `${new Date().getTimezoneOffset()}`)
        });

        return next.handle(contextRequest);
    }
}
